<script setup lang="ts">
import Message from 'primevue/message';
</script>

<template>
  <Message
    severity="info"
    :closable="false"
    data-testid="max-bid-explanation"
  >
    Set the highest amount you'd pay. We bid the minimum on your behalf
    and only raise as others bid against you, up to your max. If two
    bidders set the same max, the bidder who set it first wins.
  </Message>
</template>
